import api from '../lib/api';

export const RUNS_LOADING = 'RUNS_LOADING';
export const FETCH_RUNS = 'FETCH_RUNS';
export const FETCH_RUN_TASKS = 'FETCH_RUN_TASKS';
export const CREATE_RUN = 'CREATE_RUN';
export const CREATE_DYNAMIC_RUN = 'CREATE_DYNAMIC_RUN';
export const UPDATE_RUN = 'UPDATE_RUN';
export const DELETE_RUN = 'DELETE_RUN';

function fetchRuns(query) {
  return (dispatch) => {
    dispatch({ type: RUNS_LOADING, payload: true });

    return api.getRuns(query)
      .then((data) => {
        dispatch({ type: FETCH_RUNS, payload: data.data });
        return data;
      })
      .then((data) => {
        dispatch({ type: RUNS_LOADING, payload: false });
        return data;
      });
  };
}

function fetchRunTasks(runId) {
  return (dispatch) => {
    dispatch({ type: RUNS_LOADING, payload: true });

    return api.getRunTasks(runId)
      .then((data) => {
        dispatch({ type: FETCH_RUN_TASKS, payload: { runTasks: data.data, runId } });
      })
      .then(() => {
        dispatch({ type: RUNS_LOADING, payload: false });
      })
      .catch(() => {
        dispatch({ type: RUNS_LOADING, payload: false });
      });
  };
}

function createRun(args) {
  return (dispatch) => api.createRun(args)
    .then((data) => {
      dispatch({ type: CREATE_RUN, payload: data });
      return data;
    });
}

function createDynamicRun(args) {
  return (dispatch) => api.createDynamicRun(args)
    .then((data) => {
      dispatch({ type: CREATE_DYNAMIC_RUN, payload: data });
      return data;
    });
}

function updateRun(id, updateObj) {
  return (dispatch) => api.updateRun(id, updateObj)
    .then((data) => {
      dispatch({ type: UPDATE_RUN, payload: data });
      return data;
    });
}

function deleteRun(id) {
  return (dispatch) => api.deleteRun(id)
    .then((data) => {
      dispatch({ type: DELETE_RUN, payload: data });
      return data;
    });
}

export default {
  fetchRuns,
  fetchRunTasks,
  updateRun,
  createRun,
  createDynamicRun,
  deleteRun,
};
